const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewKioskMapaFeedlot = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'kiosk/mapa-feedlot',
        name: 'Kiosk - Mapa Feedlot',
        component: ViewKioskMapaFeedlot,
        // Sin IS_AUTENTICADO
      },
    ],
  },
]

export default router